import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// English translations
import enTopBar from "./english/top-bar/TopBar.json";
import enNavbar from "./english/navbar/NavBar.json";
import enHome from "./english/home/Home.json";
import enFooter from "./english/footer/Footer.json";
import enTeam from "./english/team/Team.json";
import enSubscription from "./english/subscription/Subscription.json";
import enNotFound from "./english/not-found/NotFound.json";
import enMagazine from "./english/magazine/Magazine.json";
import enMagazineCard from "./english/magazine/MagazineCard.json";
import enAbout from "./english/about/About.json";
import enFreeBooks from "./english/free-books/FreeBooks.json";
import enFreeBookCard from "./english/free-books/FreeBookCard.json";
// Help section translations
import enContactUs from "./english/help/ContactUs.json";
import enFAQs from "./english/help/FAQs.json";
import enPrivacyPolicy from "./english/help/PrivacyPolicy.json";
import enReturnsPolicy from "./english/help/ReturnsPolicy.json";
import enTerms from "./english/help/Terms.json";
// Auth section translations
import enRegister from "./english/auth/Register.json";
import enLogin from "./english/auth/Login.json";
import enForgotPassword from "./english/auth/ForgotPassword.json";
import enVerifyOTP from "./english/auth/VerifyOTP.json";
import enProfile from "./english/auth/Profile.json";
import enAddBookForm from "./english/auth/AddBookForm.json";
// Audio books section translations
import enAudioBookList from "./english/audio-books/AudioBookList.json";
import enFilterSection from "./english/audio-books/FilterSection.json";
import enSortDropdown from "./english/audio-books/SortDropdown.json";
import enBookCard from "./english/audio-books/BookCard.json";
// Books section translations
import enBookList from "./english/books/BookList.json";
import enBooksFilterSection from "./english/books/FilterSection.json";
import enBooksSortDropdown from "./english/books/SortDropdown.json";
import enBookDetails from "./english/books/BookDetails.json";
// Readers section translations
import enReaders from "./english/readers/Readers.json";

// Dari translations
import drTopBar from "./dari/top-bar/TopBar.json";
import drNavbar from "./dari/navbar/NavBar.json";
import drHome from "./dari/home/Home.json";
import drFooter from "./dari/footer/Footer.json";
import drTeam from "./dari/team/Team.json";
import drSubscription from "./dari/subscription/Subscription.json";
import drNotFound from "./dari/not-found/NotFound.json";
import drMagazine from "./dari/magazine/Magazine.json";
import drMagazineCard from "./dari/magazine/MagazineCard.json";
import drAbout from "./dari/about/About.json";
import drFreeBooks from "./dari/free-books/FreeBooks.json";
import drFreeBookCard from "./dari/free-books/FreeBookCard.json";
// Help section translations
import drContactUs from "./dari/help/ContactUs.json";
import drFAQs from "./dari/help/FAQs.json";
import drPrivacyPolicy from "./dari/help/PrivacyPolicy.json";
import drReturnsPolicy from "./dari/help/ReturnsPolicy.json";
import drTerms from "./dari/help/Terms.json";
// Auth section translations
import drRegister from "./dari/auth/Register.json";
import drLogin from "./dari/auth/Login.json";
import drForgotPassword from "./dari/auth/ForgotPassword.json";
import drVerifyOTP from "./dari/auth/VerifyOTP.json";
import drProfile from "./dari/auth/Profile.json";
import drAddBookForm from "./dari/auth/AddBookForm.json";
// Audio books section translations
import drAudioBookList from "./dari/audio-books/AudioBookList.json";
import drFilterSection from "./dari/audio-books/FilterSection.json";
import drSortDropdown from "./dari/audio-books/SortDropdown.json";
import drBookCard from "./dari/audio-books/BookCard.json";
// Books section translations
import drBookList from "./dari/books/BookList.json";
import drBooksFilterSection from "./dari/books/FilterSection.json";
import drBooksSortDropdown from "./dari/books/SortDropdown.json";
import drBookDetails from "./dari/books/BookDetails.json";
// Readers section translations
import drReaders from "./dari/readers/Readers.json";

// Pashto translations
import psTopBar from "./pashto/top-bar/TopBar.json";
import psNavbar from "./pashto/navbar/NavBar.json";
import psHome from "./pashto/home/Home.json";
import psFooter from "./pashto/footer/Footer.json";
import psTeam from "./pashto/team/Team.json";
import psSubscription from "./pashto/subscription/Subscription.json";
import psNotFound from "./pashto/not-found/NotFound.json";
import psMagazine from "./pashto/magazine/Magazine.json";
import psMagazineCard from "./pashto/magazine/MagazineCard.json";
import psAbout from "./pashto/about/About.json";
import psFreeBooks from "./pashto/free-books/FreeBooks.json";
import psFreeBookCard from "./pashto/free-books/FreeBookCard.json";
// Help section translations
import psContactUs from "./pashto/help/ContactUs.json";
import psFAQs from "./pashto/help/FAQs.json";
import psPrivacyPolicy from "./pashto/help/PrivacyPolicy.json";
import psReturnsPolicy from "./pashto/help/ReturnsPolicy.json";
import psTerms from "./pashto/help/Terms.json";
// Auth section translations
import psRegister from "./pashto/auth/Register.json";
import psLogin from "./pashto/auth/Login.json";
import psForgotPassword from "./pashto/auth/ForgotPassword.json";
import psVerifyOTP from "./pashto/auth/VerifyOTP.json";
import psProfile from "./pashto/auth/Profile.json";
import psAddBookForm from "./pashto/auth/AddBookForm.json";
// Audio books section translations
import psAudioBookList from "./pashto/audio-books/AudioBookList.json";
import psFilterSection from "./pashto/audio-books/FilterSection.json";
import psSortDropdown from "./pashto/audio-books/SortDropdown.json";
import psBookCard from "./pashto/audio-books/BookCard.json";
// Books section translations
import psBookList from "./pashto/books/BookList.json";
import psBooksFilterSection from "./pashto/books/FilterSection.json";
import psBooksSortDropdown from "./pashto/books/SortDropdown.json";
import psBookDetails from "./pashto/books/BookDetails.json";
// Readers section translations
import psReaders from "./pashto/readers/Readers.json";


const resources = {
  en: {
    translation: {
      topBar: enTopBar,
      navbar: enNavbar,
      home: enHome,
      footer: enFooter,
      team: enTeam,
      subscription: enSubscription,
      notFound: enNotFound,
      magazine: enMagazine,
      magazineCard: enMagazineCard,
      about: enAbout,
      freeBooks: enFreeBooks,
      freeBookCard: enFreeBookCard,
      help: {
        contactUs: enContactUs,
        faqs: enFAQs,
        privacyPolicy: enPrivacyPolicy,
        returnsPolicy: enReturnsPolicy,
        terms: enTerms
      },
      auth: {
        register: enRegister,
        login: enLogin,
        forgotPassword: enForgotPassword,
        verifyOTP: enVerifyOTP,
        profile: enProfile,
        addBookForm: enAddBookForm
      },
      audioBooks: {
        list: enAudioBookList,
        filter: enFilterSection,
        sort: enSortDropdown,
        card: enBookCard
      },
      books: {
        list: enBookList,
        filter: enBooksFilterSection,
        sort: enBooksSortDropdown,
        details: enBookDetails
      },
      readers: enReaders
    },
  },
  dr: {
    translation: {
      topBar: drTopBar,
      navbar: drNavbar,
      home: drHome,
      footer: drFooter,
      team: drTeam,
      subscription: drSubscription,
      notFound: drNotFound,
      magazine: drMagazine,
      magazineCard: drMagazineCard,
      about: drAbout,
      freeBooks: drFreeBooks,
      freeBookCard: drFreeBookCard,
      help: {
        contactUs: drContactUs,
        faqs: drFAQs,
        privacyPolicy: drPrivacyPolicy,
        returnsPolicy: drReturnsPolicy,
        terms: drTerms
      },
      auth: {
        register: drRegister,
        login: drLogin,
        forgotPassword: drForgotPassword,
        verifyOTP: drVerifyOTP,
        profile: drProfile,
        addBookForm: drAddBookForm
      },
      audioBooks: {
        list: drAudioBookList,
        filter: drFilterSection,
        sort: drSortDropdown,
        card: drBookCard
      },
      books: {
        list: drBookList,
        filter: drBooksFilterSection,
        sort: drBooksSortDropdown,
        details: drBookDetails
      },
      readers: drReaders
    },
  },
  ps: {
    translation: {
      topBar: psTopBar,
      navbar: psNavbar,
      home: psHome,
      footer: psFooter,
      team: psTeam,
      subscription: psSubscription,
      notFound: psNotFound,
      magazine: psMagazine,
      magazineCard: psMagazineCard,
      about: psAbout,
      freeBooks: psFreeBooks,
      freeBookCard: psFreeBookCard,
      help: {
        contactUs: psContactUs,
        faqs: psFAQs,
        privacyPolicy: psPrivacyPolicy,
        returnsPolicy: psReturnsPolicy,
        terms: psTerms
      },
      auth: {
        register: psRegister,
        login: psLogin,
        forgotPassword: psForgotPassword,
        verifyOTP: psVerifyOTP,
        profile: psProfile,
        addBookForm: psAddBookForm
      },
      audioBooks: {
        list: psAudioBookList,
        filter: psFilterSection,
        sort: psSortDropdown,
        card: psBookCard
      },
      books: {
        list: psBookList,
        filter: psBooksFilterSection,
        sort: psBooksSortDropdown,
        details: psBookDetails
      },
      readers: psReaders
    },
  },
};

// ----------------------------------------------------------------------

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    resources: resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
